import { FrequentPassageRequest } from '@legacy-types';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';

type DownloadFrequentPassageRequestVoucherButtonProps = {
  frequentPassageRequest: FrequentPassageRequest;
};

export function DownloadFrequentPassageRequestVoucherButton({
  frequentPassageRequest,
}: DownloadFrequentPassageRequestVoucherButtonProps) {
  return (
    <Button size="sm" disabled={!frequentPassageRequest.downloadUrl} asChild>
      <a href={frequentPassageRequest.downloadUrl ?? undefined} download>
        <Icon icon="download" />
        Voucher
      </a>
    </Button>
  );
}
